import { Id } from "src/utils/types";
import { request } from ".";

export const userTypes = {
    PSICOLOGO: "PSICOLOGO",
    EMPRESA: "EMPRESA",
    ADM_EMPRESA: "ADM-EMPRESA",
    ADMINISTRADOR: "ADMINISTRADOR",
}

// Rótulos amigáveis exibidos no select (o valor salvo é o da direita).
export const userTypeLabels: Record<string, string> = {
    PSICOLOGO: "Psicólogo",
    EMPRESA: "Empresa",
    "ADM-EMPRESA": "Administrador da empresa",
    ADMINISTRADOR: "Administrador",
}

export type UserTypes = keyof typeof userTypes;

export type PostUserRequest = {
    email:  string;
    password:  string;
    name:  string;
    id_empresa:  number;
    monthly_payment_value: number;
    type: UserTypes | '';
}

export type User = {
    id: number,
    name: string,
    email: string,
    company_id: number,
    company: string,
    type: UserTypes,
    monthly_payment_value: number,
}

export type ChangeUserPasswordRequest = {
    current_password: string;
    new_password: string;
}

export type UserNotification = {
    user_notification_id: number,
    id_destinatario: number,
    nome_destinatario: string,
    email_destinatario: string,
    id_remetente: number,
    nome_remetente: string,
    email_remetente: string,
    notificacao_de_plataforma: boolean,
    lida: boolean,
    criado_em: string,
    publicado_em: string,
    lida_em: string,
    tipo: string,
    mensagem: string,
    prioridade: string,
}

export enum NotificationTarget {
  ALL_USERS = "ALL_USERS",
  ALL_COMPANIES = "ALL_COMPANIES",
  ALL_PSYCHOLOGISTS = "ALL_PSYCHOLOGISTS",
  ONE_USER = "ONE_USER",
}

export type CreateNotificationPayload = {
  target: NotificationTarget,
  published_to_user_id: Id,
  subject: string,
  message: string,
}

export type UserNotificationCount = {
    unread: number
}

export const getUsers = async (): Promise<User[]> => {
    const response = await request.get<User[]>(`/users`);

    if (!response) {
        return [];
    }

    return response.data;
}

export const getUserById = async (id: Id): Promise<User> => {
    const response = await request.get<User>(`/users/${id}`);

    return response.data;
}

export const createUser = async (data: PostUserRequest): Promise<void> => {
    await request.post("/users", data);
}


export const updateUser = async (id: Id, data: PostUserRequest): Promise<void> => {
    await request.put(`/users/${id}`, data);
}

export const changeUserPassword = async (id: Id, data: ChangeUserPasswordRequest): Promise<void> => {
    try {
        await request.put(`/users/${id}/change-password`, data);
    } catch (error) {
        console.error("Erro ao alterar senha:", error);
        throw error;
    }
}

export const deleteUserById = async (id: Id): Promise<void> => {
    await request.delete(`/users/${id}`);
}

export const getUserNotifications = async (page: number): Promise<UserNotification[]> => {
    const response = await request.get<UserNotification[]>(`/users/notifications`, {
        params: {
            page: page,
            type: 'FRONTEND',
        }
    });

    if (!response) {
        return [];
    }

    return response.data;
}

export const getUnreadNotificationsCount = async (page: number): Promise<number> => {
    const response = await request.get<UserNotificationCount>(`/users/notifications/unread-count`, {
        params: {
            type: 'FRONTEND',
        }
    });

    if (!response) {
        return 0;
    }

    return response.data["unread"] ?? 0;
}

export const markUserNotificationAsRead = async(id: Id): Promise<void> => {
    await request.post(`/users/notifications/${id}/mark-as-read`);
}

export async function createNotification(payload: CreateNotificationPayload): Promise<void> {
    await request.post(`/users/notifications`, payload);
}
